import {updateLastMessage} from "@breachrx/streaming";
import pluralize from "pluralize";
import {isBoolean, isEmpty, isNumber, omit, reject, some} from "underscore";

const MESSAGE_METADATA_FIELDS = ["messageId", "sender", "createdAt", "activity", "resumeRequestId"];

const hasMeaningfulMessageValue = (value) => {
  if (isBoolean(value)) {
    return value;
  }
  if (isNumber(value)) {
    return true;
  }

  return !isEmpty(value);
};

const isActivityOnlyMessage = (message, messageId) => {
  const messageContent = omit(message, MESSAGE_METADATA_FIELDS);

  return (
    message?.messageId === messageId &&
    message.sender === "assistant" &&
    !isEmpty(message.activity) &&
    !some(messageContent, hasMeaningfulMessageValue)
  );
};

export const clearMessageActivity = (setMessages, messageId) => {
  if (!messageId) {
    return;
  }

  updateLastMessage(
    setMessages,
    {activity: undefined},
    (message) => message?.messageId === messageId,
  );
};

export const removeActivityOnlyMessage = (setMessages, messageId) => {
  if (!messageId) {
    return;
  }

  setMessages((messages) =>
    reject(messages, (message) => isActivityOnlyMessage(message, messageId)),
  );
};

export const buildAssistantStreamMessage = (messageId, metadata = {}) => ({
  messageId,
  text: "",
  sender: "assistant",
  createdAt: Date.now(),
  ...metadata,
});

export const buildConfirmationErrorMessage = ({confirmationId, agentErrors}) =>
  buildAssistantStreamMessage(
    `errors-${confirmationId}`,
    {
      text: `_⚠️ ${pluralize("step", agentErrors.length, true)} couldn't be completed._`,
      agentErrors,
    },
  );
